import { fetchApi } from '@/lib/api/client'
import type { ActivitiesSnapshot, ActivityDto } from './types'

export const ACTIVITIES_PATH = '/activities'
/** The server-sent-events twin of GET /activities. */
export const ACTIVITIES_STREAM_PATH = '/activities/stream'

export const activitiesKeys = {
  all: ['activities'] as const,
  snapshot: () => [...activitiesKeys.all, 'snapshot'] as const,
}

export function fetchActivities(): Promise<ActivitiesSnapshot> {
  return fetchApi<ActivitiesSnapshot>(ACTIVITIES_PATH)
}

const STATES = new Set(['queued', 'running', 'paused', 'finished', 'finished_with_failures', 'cancelled', 'failed'])

/**
 * A stream frame as a snapshot, or null when it is not one. The stream is trusted no further than
 * its shape: a frame the dock cannot read is dropped (the next poll or frame replaces it), never
 * drawn half-way.
 */
export function parseSnapshot(raw: string): ActivitiesSnapshot | null {
  try {
    const value = JSON.parse(raw) as Partial<ActivitiesSnapshot> | null
    if (!value || !Array.isArray(value.activities)) return null
    const readable = value.activities.every(
      (a: Partial<ActivityDto>) =>
        !!a && typeof a.id === 'string' && typeof a.kind === 'string' && STATES.has(a.state as string) && !!a.counts,
    )
    if (!readable) return null
    return {
      activities: value.activities as ActivityDto[],
      unavailable: Array.isArray(value.unavailable) ? value.unavailable : [],
      generatedAt: typeof value.generatedAt === 'string' ? value.generatedAt : '',
      version: typeof value.version === 'string' ? value.version : '',
    }
  } catch {
    return null
  }
}
